import $ from 'jquery';
import * as Core from 'Util/core';
import { publish, subscribe } from 'Util/pubsub';

var NavLarge;
var $nav;
var selectors;
var classes;

var navHeight;
var navPos;
var topPos;

var $window;
var $body;
var $anchorLinks;
var $navWithMenus;
var $megaMenu;

var NavLarge = {
    init: function ($elm, selectorList, classList) {
        NavLarge = this;
        $nav = $elm;
        selectors = selectorList;
        classes = classList;

        NavLarge._initElements();
        NavLarge._setSizes();
        NavLarge._initSubscriptions();
        NavLarge._initEvents();
    },

    _setSizes: function () {
        navHeight = $nav.outerHeight();
        navPos = $nav.offset().top;
    },

    _initElements: function () {
        $window = $(window);
        $body = $('body');
        $navWithMenus = $nav.find(selectors.navItemMega);
        $megaMenu = $nav.find(selectors.navItemMegaMenu);
        $anchorLinks = $('.js-anchor-link');
    },

    // Listen for window resize event (listener bound on all.js)
    _initSubscriptions: function () {
        //subscribe('/window/resize', NavLarge._setSizes);
    },

    _initEvents: function () {
        $anchorLinks.on('click', NavLarge._processAnchorClick);

        this._bindEvents();
    },

    _bindEvents: function () {

        // Detect if device is touch-enabled
        var isTouchDevice = ('ontouchstart' in window || navigator.maxTouchPoints > 0);

        $navWithMenus.each(function () {

            // Hover if not touch device
            if (!isTouchDevice) {
                // Open mega menu on hover
                $(this).find(selectors.megamenuHeading).on('mouseenter', NavLarge._toggleHoverMegaMenuEvent);

                // Keep mega menu open when hovering over it
                $(this).find(selectors.navItemMegaMenu).on('mouseenter', function () {
                    // do nothing to prevent menu from closing when hovering over mega menu
                }).on('mouseleave', function () {
                    // close mega menu when mouse leaves mega menu area
                    $(this).closest(selectors.navItemMega).attr('aria-expanded', false);
                });

                // Close mega menu on mouse leave of nav item
                $(this).on('mouseleave', function () {
                    $(this).attr('aria-expanded', false);
                });

                // Click to open/close mega menu on touch devices
            } else {
                $(this).find(selectors.megamenuHeading).on('click', NavLarge._toggleClickMegaMenuEvent);
            }
        });

        $('body').on('click', NavLarge._handleBodyClick);
    },

    // publish nav toggle event on hover
    _toggleHoverMegaMenuEvent: function (event) {
        publish('/nav/navToggle');
        NavLarge._toggleHoverMegaMenu(this, 'hover', event);
    },

    // publish nav toggle event on click
    _toggleClickMegaMenuEvent: function (event) {
        publish('/nav/navToggle');
        NavLarge._toggleClickMegaMenu(this, 'click', event);
    },

    // toggle mega menu on hover
    _toggleHoverMegaMenu: function (target, hover, event) {

        var $thisTarget = $(target);
        var $thisNav = $thisTarget.is(selectors.navItemMega) ? $thisTarget : $thisTarget.closest(selectors.navItemMega);
        var $expanded = $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]');

        if ($expanded.find(selectors.megamenuHeading)[0] !== target) {
            $expanded.attr('aria-expanded', false);
            $expanded.addClass(classes.allowAnimations);
        }

        if ($thisNav.attr('aria-expanded') === 'true') {
            $thisNav.attr('aria-expanded', false);
            $thisNav.addClass(classes.allowAnimations);
        } else {
            $thisNav.attr('aria-expanded', true);
            $thisNav.addClass(classes.allowAnimations);
        }
    },

    // toggle mega menu on click
    _toggleClickMegaMenu: function (target, click, event) {

        if (click === 'click') {
            event.preventDefault();
        }

        var $thisTarget = $(target);
        var $thisNav = $thisTarget.is(selectors.navItemMega) ? $thisTarget : $thisTarget.closest(selectors.navItemMega);
        var $expanded = $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]');

        if (click && click === 'click' && $expanded.find(selectors.megamenuHeading)[0] !== target) {
            $expanded.attr('aria-expanded', false);
            $expanded.addClass(classes.allowAnimations);
        }

        if ($thisNav.attr('aria-expanded') === 'true') {
            $thisNav.attr('aria-expanded', false);
            $thisNav.addClass(classes.allowAnimations);
        } else {
            $thisNav.attr('aria-expanded', true);
            $thisNav.addClass(classes.allowAnimations);
        }
    },

    _processAnchorClick: function (event) {
        event.preventDefault();

        var hash = this.href.split('#')[1];
        var $anchor = $('#' + hash);

        if ($anchor.length) {
            Core.scrollToElm($anchor, navHeight - 1);
        }
    },

    _handleBodyClick: function (e) {
        var $target = $(e.target);
        var $expandedItem;

        if (!$target.closest(selectors.nav).length && $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]').length) {
            $expandedItem = $nav.find(selectors.navItemMega).filter('[aria-expanded="true"]');

            $expandedItem.attr('aria-expanded', false);
            $expandedItem.addClass(classes.allowAnimations);
        }
    },

    _unbindClickEvents: function () {
        $navWithMenus.each(function () {
            $(this).find(selectors.megamenuHeading).off('mouseenter', NavLarge._toggleHoverMegaMenuEvent);
            $(this).find(selectors.navItemMegaMenu).off('mouseenter', function () { }).off('mouseleave', function () {
                $(this).closest(selectors.navItemMega).attr('aria-expanded', false);
            });

            $(this).off('mouseleave', function () {
                $(this).attr('aria-expanded', false);
            });

            $(this).find(selectors.megamenuHeading).on('click', NavLarge._toggleClickMegaMenuEvent);
        });

        $('body').off('click', NavLarge._handleBodyClick);
    },

    unbind: function () {
        $anchorLinks.off('click', NavLarge._processAnchorClick);
        $navWithMenus.off('click', this._toggleMegaMenu);
        $navWithMenus.off('mouseenter').off('mouseleave');
        $navWithMenus.removeProp('hoverIntent_t');
        $navWithMenus.removeProp('hoverIntent_s');

        this._unbindClickEvents();
    },
};

export { NavLarge };
